export default __webpack_public_path__ + "static/media/bnr1.9d33c6de.jpg";